"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.promiseTimeout = void 0;
const errors_1 = require("./errors");
function promiseTimeout(timeoutInMsec, promise) {
    let timeout = new Promise((resolve, reject) => {
        setTimeout(() => {
            reject(new errors_1.AuthError(errors_1.AuthErrorCode.TIMEOUT, `Timed out in ${timeoutInMsec} ms.`));
        }, timeoutInMsec);
    });
    return Promise.race([promise, timeout]);
}
exports.promiseTimeout = promiseTimeout;
